<template>
  <button-dialog-container
    :btn-icon="icon"
    :size="getSize"
    :only-icon="true"
    :no-tool-tip="noToolTip"
    :width-dialog="800"
    :dialog-viewer.sync="dialog"
    :title-tool-tip="titleToolTip"
    @ok-pushed="returnText"
    @cancel-pushed="outsideClick"
    @outside-click="outsideClick"
  >
    <v-container class="pa-4">
      <v-row>
        <v-col cols="7">
          <v-row>
            <v-stage
              ref="creationPageWorkspace"
              :config="configKonva"
            />
          </v-row>
          <v-row>
            <v-col class="mt-16">
              <v-combobox
                v-model="textList"
                :label="label"
                :value="textList"
                :placeholder="placeholder"
                chips
                autofocus
                deletable-chips
                cache-items
                multiple
                clearable
                dense
                @click:clear="generate()"
                @input="generate()"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1">
          <v-divider
            class="ml-4"
            vertical
          />
        </v-col>
        <v-col cols="4">
          <v-row dense>
            <v-subheader>
              {{ $t("creation.tools.dialog.rss.display") }}
            </v-subheader>
            <v-radio-group
              v-model="axeScrolling"
              row
              class="marginZero"
              @change="generate()"
            >
              <v-radio
                class="d-flex pa=0 ma=0"
                :label="$t('creation.tools.dialog.rss.horizontal')"
                :value="true"
                off-icon="mdi-arrow-expand-horizontal"
                on-icon="mdi-arrow-expand-horizontal"
                @change="axeChange()"
              />
              <v-radio
                class="d-flex pa=0 ma=0"
                :label="$t('creation.tools.dialog.rss.vertical')"
                :value="false"
                off-icon="mdi-arrow-expand-vertical"
                on-icon="mdi-arrow-expand-vertical"
                @change="axeChange()"
              />
            </v-radio-group>
          </v-row>
          <v-row dense>
            <v-switch
              v-model="sensScrolling"
              class="marginZero"
              :label="$t('creation.tools.dialog.rss.direction')"
              @change="generate()"
            />
          </v-row>
          <v-row>
            <v-divider class="mb-4 mt-n4" />
          </v-row>
          <v-row dense>
            <v-col
              cols="11"
              class="mt-n2 ml-n2"
            >
              <v-subheader class="marginZero">
                {{ $t("creation.tools.dialog.rss.speed") }}
              </v-subheader>
            </v-col>
            <v-col
              cols="1"
              class="mt-1 ml-2"
            >
              <v-tooltip
                top
                :max-width="160"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dark
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ $t("creation.tools.dialog.rss.text-speed") }}</span>
              </v-tooltip>
            </v-col>
            <v-col>
              <v-slider
                v-model="speed"
                step="10"
                min="10"
                max="200"
                thumb-label
                ticks
                append-icon="mdi-plus-circle-outline"
                prepend-icon="mdi-minus-circle-outline"
                @click:append="velocityMore"
                @click:prepend="velocityLess"
                @input="generate()"
              />
            </v-col>
          </v-row>
          <!-- DIVIDER -->
          <v-row class="mb-4 mt-n4">
            <v-divider />
          </v-row>
          <v-row>
            <v-select
              v-model="align"
              :items="btnAlign"
              item-text="name"
              item-value="value"
              dense
              outlined
              :label="$t('option.align')"
              @change="clickAlign()"
            />
          </v-row>
          <v-row>
            <v-combobox
              v-model="size"
              :items="btnSize"
              dense
              outlined
              :label="$t('option.size')"
              @change="clickSize()"
            />
          </v-row>
          <v-row>
            <v-combobox
              v-model="font"
              :items="btnFont"
              dense
              outlined
              :label="$t('option.font')"
              @change="clickFont()"
            />
          </v-row>
          <!-- DIVIDER -->
          <v-row class="mb-2 mt-n2">
            <v-divider />
          </v-row>
          <v-row
            dense
            class="mt-n2"
          >
            <v-col>
              <v-row>
                <v-col
                  cols="11"
                  class="ml-n4"
                >
                  <v-subheader>
                    {{ $t("creation.tools.dialog.rss.spacing") }}
                  </v-subheader>
                </v-col>
                <v-col
                  cols="1"
                  class="mt-3 ml-3"
                >
                  <v-tooltip
                    top
                    :max-width="160"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("creation.tools.dialog.rss.text-distance") }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="mt-n5">
                  <v-slider
                    v-model="entraxe"
                    step="1"
                    min="1"
                    max="10"
                    thumb-label
                    ticks
                    append-icon="mdi-plus-circle-outline"
                    prepend-icon="mdi-minus-circle-outline"
                    @click:append="entraxeMore"
                    @click:prepend="entraxeLess"
                    @input="generate()"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </button-dialog-container>
</template>

<script>
// Components
import buttonDialogContainer from "../Common/ButtonDialogContainer";
import Konva from "konva";

export default {
  components: {
    buttonDialogContainer,
  },
  props: {
    currentObject: {
      type: Object,
      default: () => {},
    },
    icon: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    toolName: {
      type: String,
      default: "",
    },
    titleToolTip: {
      type: String,
      default: "",
    },
    noToolTip: {
      type: Boolean,
      default: false,
    },
    getSize: {
      type: Number,
      default: 25,
    },
  },
  data() {
    return {
      dialog: false,
      entraxe: 1,
      size: 48,
      font: this.$store.state.vars.font.default,
      btnFont: this.$store.state.vars.font.family,
      btnSize: this.$store.state.vars.font.size,
      btnAlign: [
        { value: "left", name: this.$t("align.left") },
        { value: "center", name: this.$t("align.center") },
        { value: "right", name: this.$t("align.right") },
        { value: "justify", name: this.$t("align.justify") },
      ],
      speed: 50,
      sensScrolling: false,
      textList: [],
      textEntered: "",
      axeScrolling: true,
      align: "left",
      baseConfigKonva: {
        x: 0,
        y: 0,
        width: 450,
        height: 400,
        scale: {
          x: this.scale,
          y: this.scale,
        },
      },
    };
  },
  computed: {
    stage() {
      return this.$refs.creationPageWorkspace.getStage();
    },
    configKonva() {
      return this.baseConfigKonva;
    },
    open() {
      return this.$store.state.widget.openEditScrolling;
    },
  },
  watch: {
    open: function () {
      if (this.open) {
        this.setConfig();
        this.dialog = true;
        this.dblclick = true;
        this.$store.dispatch("editClose").widget;
      }
    },
  },
  created() {
    //this.createText("Cliquer hors de la zone pour avoir une demo")
  },
  methods: {
    setConfig() {
      this.textList.push(this.currentObject.dataScrolling.text);
      this.size = this.currentObject.dataScrolling.size;
      this.font = this.currentObject.dataScrolling.font;
      this.axeScrolling = this.currentObject.dataScrolling.axe;
      this.sensScrolling = this.currentObject.dataScrolling.sens;
      this.color = this.currentObject.dataScrolling.color;
      this.speed = this.currentObject.dataScrolling.speed;
      this.align = this.currentObject.dataScrolling.align;
    },
    scrollingHorizontal(textEntered) {
      let start = 0;
      let end = true;
      const layer = new Konva.Layer();
      let absoluteX = this.stage.width();

      const firstText = this.firstText(textEntered);
      const secondText = this.firstText(textEntered);

      const rect = new Konva.Rect({
        x: 0,
        y: 0,
        width: absoluteX,
        height: firstText.size().height,
      });

      firstText.x(absoluteX);
      secondText.x(absoluteX);
      rect.x(absoluteX);
      firstText.y(this.stage.height() - firstText.size().height);
      secondText.y(this.stage.height() - secondText.size().height);
      rect.y(this.stage.height() - rect.size().height);

      const group = new Konva.Group({
        draggable: true,
        dragBoundFunc: function (pos) {
          return {
            x: this.absolutePosition().x,
            y: pos.y,
          };
        },
      });

      group.add(rect, firstText, secondText);
      layer.add(group);
      this.stage.add(layer);

      const velocity = this.speed;
      if (absoluteX * 0.7 < firstText.size().width) {
        start = -(firstText.size().width - absoluteX * 0.3);
      }

      const anim = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        firstText.move({ x: -dist, y: 0 });
        if (firstText.x() <= -firstText.size().width) {
          firstText.x(absoluteX);
          anim.stop();
        }
        if (firstText.x() <= start && end) {
          anim2.start();
          end = false;
        }
      }, layer);

      anim.start();

      const anim2 = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        secondText.move({ x: -dist, y: 0 });
        if (secondText.x() <= -secondText.size().width) {
          secondText.x(absoluteX);
          anim2.stop();
        }
        if (secondText.x() <= start && !end) {
          anim.start();
          end = true;
        }
      }, layer);

      this.anim = anim;
      this.anim2 = anim2;
    },
    scrollingVertical(textEntered) {
      let start = 0;
      let end = true;
      const layer = new Konva.Layer();
      let absoluteY = this.stage.height();

      const firstText = this.firstText(textEntered);
      const secondText = this.firstText(textEntered);

      const rect = new Konva.Rect({
        x: 0,
        y: 0,
        width: firstText.size().width,
        height: this.stage.height(),
      });

      firstText.y(absoluteY);
      secondText.y(absoluteY);
      rect.y(absoluteY);

      const group = new Konva.Group({
        draggable: true,
        dragBoundFunc: function (pos) {
          return {
            x: pos.x,
            y: this.absolutePosition().y,
          };
        },
      });

      if (absoluteY * 0.7 < firstText.size().height) {
        start = -(firstText.size().height - absoluteY * 0.3);
      }
      group.add(rect, firstText, secondText);
      layer.add(group);
      this.stage.add(layer);

      const velocity = this.speed;

      const anim = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        firstText.move({ x: 0, y: -dist });
        if (firstText.y() <= -firstText.size().height + 10) {
          firstText.y(absoluteY);
          anim.stop();
        }
        if (firstText.y() <= start && end) {
          anim2.start();
          end = false;
        }
      }, layer);

      anim.start();

      const anim2 = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        secondText.move({ x: 0, y: -dist });
        if (secondText.y() <= -secondText.size().height) {
          secondText.y(absoluteY);
          anim2.stop();
        }
        if (secondText.y() <= start && !end) {
          anim.start();
          end = true;
        }
      }, layer);

      this.anim = anim;
      this.anim2 = anim2;
    },
    scrollingHorizontalReverse(textEntered) {
      let end = true;
      const layer = new Konva.Layer();
      let absoluteX = this.stage.width();

      const firstText = this.firstText(textEntered);
      const secondText = this.firstText(textEntered);

      const rect = new Konva.Rect({
        x: 0,
        y: 0,
        width: this.stage.width(),
        height: firstText.size().height,
      });

      let start = this.stage.width() - firstText.size().width;

      const group = new Konva.Group({
        draggable: true,
        dragBoundFunc: function (pos) {
          return {
            x: this.absolutePosition().x,
            y: pos.y,
          };
        },
      });

      firstText.x(-firstText.size().width);
      secondText.x(-secondText.size().width);
      firstText.y(this.stage.height() - firstText.size().height);
      secondText.y(this.stage.height() - secondText.size().height);
      rect.y(this.stage.height() - rect.size().height);

      group.add(rect, firstText, secondText);
      layer.add(group);
      this.stage.add(layer);

      const velocity = this.speed;
      if (absoluteX * 0.7 < firstText.size().width) {
        start = this.stage.width() * 0.7;
      }
      const anim = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        firstText.move({ x: dist, y: 0 });
        if (firstText.x() >= absoluteX) {
          firstText.x(-firstText.size().width);
          anim.stop();
        }
        if (firstText.x() >= start && end) {
          anim2.start();
          end = false;
        }
      }, layer);

      anim.start();

      const anim2 = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        secondText.move({ x: dist, y: 0 });
        if (secondText.x() >= absoluteX) {
          secondText.x(-secondText.size().width);
          anim2.stop();
        }
        if (secondText.x() >= start && !end) {
          anim.start();
          end = true;
        }
      }, layer);

      this.anim = anim;
      this.anim2 = anim2;
    },
    scrollingVerticalReverse(textEntered) {
      let end = true;
      const layer = new Konva.Layer();
      let absoluteY = this.stage.height();

      const firstText = this.firstText(textEntered);
      const secondText = this.firstText(textEntered);

      const rect = new Konva.Rect({
        x: 0,
        y: this.stage.height(),
        width: firstText.size().width,
        height: this.stage.height(),
      });

      let start = absoluteY - firstText.size().height;

      firstText.y(-firstText.size().height);
      secondText.y(-secondText.size().height);
      rect.y(-rect.size().height);

      const group = new Konva.Group({
        draggable: true,
        dragBoundFunc: function (pos) {
          return {
            x: pos.x,
            y: this.absolutePosition().y,
          };
        },
      });

      group.add(rect, firstText, secondText);
      layer.add(group);
      this.stage.add(layer);

      const velocity = this.speed;
      if (absoluteY * 0.7 < firstText.size().height) {
        start = this.stage.height() * 0.7;
      }

      const anim = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        firstText.move({ x: 0, y: dist });
        if (firstText.y() >= absoluteY) {
          firstText.y(-firstText.size().height);
          anim.stop();
        }
        if (firstText.y() >= start && end) {
          anim2.start();
          end = false;
        }
      }, layer);

      anim.start();

      const anim2 = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        secondText.move({ x: 0, y: dist });
        if (secondText.y() >= absoluteY) {
          secondText.y(-secondText.size().height);
          anim2.stop();
        }
        if (secondText.y() >= start && !end) {
          anim.start();
          end = true;
        }
      }, layer);

      this.anim = anim;
      this.anim2 = anim2;
    },
    generate() {
      this.transformText();
      if (this.textEntered.length > 0 && this.size > 8 && this.size < 150) {
        this.stage.destroyChildren();
        this.stage.clear();
        this.stage.clearCache();
        if (this.axeScrolling) {
          if (this.sensScrolling) {
            this.scrollingHorizontalReverse(this.textEntered);
          } else {
            this.scrollingHorizontal(this.textEntered);
          }
        } else {
          if (this.sensScrolling) {
            this.scrollingVerticalReverse(this.textEntered);
          } else {
            this.scrollingVertical(this.textEntered);
          }
        }
      }
      this.textEntered = "";
    },
    transformText() {
      let balise = "      ";

      if (!this.axeScrolling) {
        balise = "\r\n";
      }
      for (let j = 1; j < this.entraxe; j++) {
        if (this.axeScrolling) {
          balise = balise.concat("    ");
        } else {
          balise = balise.concat("\r\n");
        }
      }
      for (let i = 0; i < this.textList.length; i++) {
        if (i == 0) {
          this.textEntered = this.textList[i];
        } else {
          this.textEntered = this.textEntered.concat(balise, this.textList[i]);
        }
      }
      if (this.textList.length <= 0) {
        this.textEntered = " ";
      }
    },
    firstText(textEntered) {
      const firstText = new Konva.Text({
        x: 0,
        y: 0,
        text: textEntered,
        fontSize: this.size,
        fontFamily: this.font,
        fill: this.color,
        align: this.align,
      });
      return firstText;
    },
    axeChange() {
      if (!this.axeScrolling) {
        this.entraxe = 1;
      } else {
        this.entraxe = 2;
      }
      this.generate();
    },
    returnText() {
      this.transformText();
      if (this.textEntered.length > 0) {
        const dataScrolling = {
          text: this.textEntered,
          axe: this.axeScrolling,
          sens: this.sensScrolling,
          speed: this.speed,
          align: this.align,
          size: this.size,
          font: this.font,
          color: this.color,
        };

        if (this.dblclick) {
          this.$emit("editElement", {
            name: "scrolling",
            content: dataScrolling,
            config: this.currentObject.konvaObjectOption,
          });
          this.dblclick = false;
        } else {
          if (this.toolName) {
            this.$emit("toolSelectedFromDialog", this.toolName);
          }

          this.$emit("textScrolling", dataScrolling);
        }
      }
      this.reset();
    },
    velocityLess() {
      this.speed = this.speed - 10 || 0;
      this.generate();
    },
    velocityMore() {
      this.speed = this.speed + 10 || 100;
      this.generate();
    },
    clickAlign() {
      this.generate();
    },
    entraxeLess() {
      this.entraxe = this.entraxe - 1 || 0;
      this.generate();
    },
    entraxeMore() {
      this.entraxe = this.entraxe + 1 || 10;
      this.generate();
    },
    clickSize() {
      if (this.size > 8 && this.size < 150) {
        this.generate();
      } else {
        this.size = 30;
      }
    },
    clickFont() {
      this.generate();
    },
    reset() {
      this.textList = [];
      this.textEntered = "";
      this.stage.clear();
      this.stage.clearCache();
      this.stage.destroyChildren();
    },
    outsideClick() {
      this.reset();
    },
  },
};
</script>

<style>
.marginZero {
  margin-top: 0px;
}

.separation {
  display: inline-flex;
  flex-direction: center;
  align-content: center;
  align-self: center;
}
</style>
